import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip, Grid, makeStyles, Typography } from '@material-ui/core';

const useStyles = makeStyles({
  htmlTooltip: {
    backgroundColor: 'rgba(244, 244, 244, 244)',
  },
  textBlackColor: {
    color: 'rgba(0, 0, 0, 0.87)',
  },
});

const GroupInfoTooltip = props => {
  const { lastPriceChange, lastPriceChangeUser, lastSoldDate, children } = props;
  const customClasses = useStyles();

  const groupInfo = (
    <Grid container direction="column" spacing={2}>
      <Grid item xs={12}>
        <Typography className={customClasses.textBlackColor}>{lastPriceChange}</Typography>
        <Typography className={customClasses.textBlackColor}>{lastPriceChangeUser}</Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography className={customClasses.textBlackColor}>{lastSoldDate}</Typography>
      </Grid>
    </Grid>
  );

  return (
    <>
      {/* eslint-disable react/jsx-one-expression-per-line */}
      <Tooltip title={groupInfo} classes={{ tooltip: customClasses.htmlTooltip }}>
        {children}
      </Tooltip>
    </>
  );
};

GroupInfoTooltip.propTypes = {
  lastPriceChange: PropTypes.string.isRequired,
  lastPriceChangeUser: PropTypes.string.isRequired,
  lastSoldDate: PropTypes.string.isRequired,
  children: PropTypes.element.isRequired,
};

export default GroupInfoTooltip;
